<template>
    <div>
        <div v-if="value.cadastro" id="cad_paciente">
            <pagamento-pendente :value="value" />

            <form @submit.prevent="validar()" :id="formName" :ref="formName">

            <template v-if="!block_operadora">

                <!-- Dados da Operadora -->
                <AzSubTitle title="Operadora / Plano"></AzSubTitle>

                <!-- optionsData="id_plano" -->
                <div class="row">
                    <div class="col col-12" :class="fl_particular || fl_sus ? 'col-md-9' : 'col-md-5'" id="primeiro-campo">
                        <az-input :edicao="edicao" 
                            sizing="sm"
                            label="Operadora / Plano" 
                            type="autocomplete" 
                            optionsMode="aql" 
                            :optionsParm="{ 
                                atendimento: true, 
                                plano_id_unidade_operacao: marcacao ? marcacao.id_unidade_operacao : null, 
                            }"
                            :optionsName="'planos.atendimento.' + ( marcacao ? marcacao.id_unidade_operacao : 'T' )"
                            service="planos.index" 
                            optionsDisplay="search"
                            :optionsSync="false"
                            v-model="value.paciente_unidade.plano"
                            required 
                            :validate="validate">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3" v-if="!fl_particular && !fl_sus">
                        <az-input 
                            sizing="sm"
                            label="Número da Matrícula" 
                            type="text" 
                            v-model="value.paciente_unidade.st_numero_carteira"
                            :required="!fl_particular && value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_exigir_matricula" 
                            :validate="validate" 
                            :edicao="edicao && !value.paciente_unidade.eleg"                       
                            >
                            <template v-slot:buttonposb v-if="(value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_servico_elegibilidade) || is_coopeder()">
                                <servico-operadora 
                                    :elegivel="value.paciente_unidade.eleg" 
                                    :paciente="value" 
                                    :marcacao="marcacao" 
                                    :plano="value.paciente_unidade.plano" 
                                    @changeElegebilidade="elegibilidade"
                                />        
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2" v-if="!fl_particular && !fl_sus">
                        <az-input 
                            sizing="sm"
                            :edicao="edicao && !value.paciente_unidade.eleg" 
                            label="Vencimento da Matrícula" 
                            type="date"
                            v-model="value.paciente_unidade.dt_validade_carteira" 
                            :required="!fl_particular && value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_exigir_matricula" 
                            :validate="validate"/>
                            <!-- :rules="['futuro']" -->
                    </div>
                    <div class="col col-12" :class="( fl_particular || fl_sus ) ? 'col-md-3' : 'col-md-2'">
                        <az-input 
                            :edicao="edicao" 
                            label="Cartão SUS"
                            sizing="sm"
                            :required="fl_sus && !sus_block_obrig"
                            type="cns" 
                            v-model="value.paciente_unidade.st_sus" 
                            :validate="validate"
                            :rules="['size:15']">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="value.paciente_unidade.st_sus">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="copiar_clipboard(value.paciente_unidade.st_sus)" title="Copiar">
                                        <i class="fa-solid fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row" v-if="marcacao && marcacao.plano && value.id_pessoa && value.paciente_unidade.plano && ( value.paciente_unidade.plano.id_plano != value.paciente_unidade.id_plano )"><!-- marcacao.id_plano -->
                    <div class="col col-12">
                        <az-input 
                            sizing="sm"
                            :label="'Alterar Operadora/Plano do Paciente' + (value.paciente_unidade.plano_original ? ' | Atual: ' + value.paciente_unidade.plano_original.search : '' )" 
                            type="checkbox-group"
                            v-model="value.paciente_unidade.alter_plano_paciente" />
                    </div>
                </div>

                <!-- Dados Pessoais -->
                <AzSubTitle title="Dados Pessoais"></AzSubTitle>

            </template>

            <div class="row">
                <div class="col col-12" :class="tem_prontuario ? 'col-md-4' : 'col-md-6'">
                    <az-input :edicao="edicao && !block_alter_nome" label="Nome" 
                        sizing="sm"
                        type="text" v-model="value.st_nome" 
                        required :validate="validate" :rules="['nome']" />
                </div>
                <div class="col col-12 col-md-2" v-if="tem_prontuario">
                    <az-input
                        label="Prontuário"
                        :edicao="edicao"
                        sizing="sm"
                        v-model="value.paciente_unidade.st_numero_prontuario">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="edicao">
                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="gerar_prontuario()"
                                    :disabled="$store.state.loading">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        :edicao="edicao" label="e-mail" 
                        sizing="sm"
                        type="email" v-model="value.cadastro.st_email" 
                        :validate="validate" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        :edicao="edicao" label="Redes Sociais" 
                        sizing="sm"
                        type="text" v-model="value.cadastro.st_rede_social" 
                        :validate="validate" />
                </div>
            </div>

            <div class="row">

                <div class="col col-12 col-md-6">

                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <AzInput :edicao="edicao" label="Sexo" 
                                sizing="sm"
                                type="sexo" v-model="value.cadastro.ch_sexo" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input :edicao="edicao" label="Data de Nascimento" 
                                sizing="sm"
                                type="date" v-model="value.cadastro.dt_nascimento"
                                :validate="validate" :rules="['nasc']" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input  
                                :edicao="edicao && !value.cadastro.fl_estrangeiro" 
                                label="CPF" 
                                sizing="sm"
                                type="cpf" v-model="value.cadastro.st_cpf" 
                                required2="value && value.cadastro 
                                    && value.cadastro.idade_anos >= 18 
                                    && !value.cadastro.fl_estrangeiro 
                                    && !value.cpf_nao_obrigatorio"
                                :validate="validate" 
                                :rules="['cpf']">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="!value.cadastro.st_cpf && ( value.cadastro.fl_estrangeiro || value.cpf_nao_obrigatorio )">
                                        <div class="input-group-text">
                                            <input type="checkbox" aria-label="Checkbox for following text input" v-model="value.cadastro.fl_estrangeiro" :disabled="!edicao">
                                        </div>
                                        <div class="input-group-text">
                                            Sem CPF
                                        </div>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input  
                                :edicao="edicao" 
                                label="RG" 
                                sizing="sm"
                                type="text" v-model="value.cadastro.st_rg" 
                                :validate="validate" :rules="['rg']" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input 
                                :edicao="edicao" 
                                label="Org Exp" 
                                sizing="sm"
                                type="text"
                                v-model="value.cadastro.st_orgao_emissor_rg" 
                                :validate="validate" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-6">
                            <AzInput :edicao="edicao" label="Nome da Mãe" 
                                sizing="sm"
                                type="text" v-model="value.cadastro.st_nome_mae" 
                                :validate="validate" :rules="['nome']" />
                        </div>
                        <div class="col col-6">
                            <AzInput :edicao="edicao" label="Nome Social" 
                                sizing="sm"
                                type="text" v-model="value.st_nome_social" 
                                :validate="validate" :rules="['nomenum']" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <div v-if="value.cadastro.telefones">
                                <az-input 
                                    sizing="sm"
                                    label="Telefone"
                                    type="fone" 
                                    v-model="value.cadastro.telefones.telefone" 
                                    :edicao="edicao" 
                                    :validate="validate">
                                </az-input>
                            </div>
                        </div>
                        <div class="col col-12 col-md-6">
                            <div v-if="value.cadastro.telefones">
                                <az-input 
                                    sizing="sm"
                                    label="Celular" 
                                    :type="value.cadastro.telefones.pc == '+' ? 'number' : 'fone'" 
                                    v-model="value.cadastro.telefones.celular" 
                                    :edicao="edicao" 
                                    :validate="validate">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <div class="dropdown">
                                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span v-if="value.cadastro.telefones.pc == '+'">EX</span>
                                                    <span v-else>BR</span>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" @click.prevent="value.cadastro.telefones.pc = '55'">BR - Número do Brasil</a>
                                                    <a class="dropdown-item" href="#" @click.prevent="value.cadastro.telefones.pc = '+'">EX - Número do Exterior</a>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="value.cadastro.telefones.celular">
                                            <a :href="whatsapp_web(value.cadastro.telefones.celular, value.cadastro.telefones.pc)" class="btn btn-sm btn-outline-success" target="_blank">
                                                <i class="fa-brands fa-whatsapp"></i>
                                            </a>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_sus">
                        <div class="col col-12 col-md-6">
                            <az-input 
                                sizing="sm"
                                label="Raça" 
                                type="select" 
                                v-model="value.cadastro.st_raca" 
                                :optionsList="[
                                    { id: '01', search: 'Branca' }, 
                                    { id: '02', search: 'Preta' }, 
                                    { id: '03', search: 'Parda' }, 
                                    { id: '04', search: 'Amarela' }, 
                                    { id: '05', search: 'Indígena' }, 
                                ]"
                                optionsData="id"
                                :required="!sus_block_obrig"
                                :edicao="edicao" 
                                :validate="validate" />
                        </div>

                        <div class="col col-12 col-md-6" v-if="value.cadastro.st_raca == '05'">
                            <az-input 
                                placeholder="Selecione..."
                                sizing="sm"
                                label="Etnia" 
                                type="select" 
                                service="pacientes.etnias" 
                                v-model="value.cadastro.st_etnia" 
                                optionsMode="aql"
                                optionsData="id"
                                required
                                :edicao="edicao" 
                                :validate="validate" />
                        </div>
                    </div>

                </div>

                <div class="col col-12 col-md-6" v-if="value.cadastro.endereco">
                    <cadastro-endereco :edicao="edicao" sizing="sm" v-model="value.cadastro.endereco" :validate="validate" />
                </div>

            </div>

            <div v-if="sinalizadores && sinalizadores.length" class="my-2 form-inline">
                <label class="form form-control mr-2">Selecione:</label>
                <button type="button" class="btn mr-1" :class=" ( sinalizador_selecionado(sinal) ? 'btn-' + sinal.st_cor : 'btn-outline-light text-muted' ) " v-for="(sinal, isx) in sinalizadores" :key="isx" 
                    :title="( sinalizador_selecionado(sinal) ? '' : 'Selecione para indicar: ' ) + sinal.st_sinalizador_atendimento" 
                    @click="toggle_sinalizador(sinal)" :disabled="!edicao" 
                    data-toggle="tooltip" data-placement="top">
                    <i :class="( sinal.st_icon ? sinal.st_icon : 'fas fa-flag' ) + ' fa-2x fa-fw'" aria-hidden="true"></i>
                </button>
            </div>

            <div v-if="value.campos_customizados" class="row">
                <div class="col col-12">
                    <az-sub-title :title="value.campos_customizados.st_titulo" />
                    <formulario 
                        :gutters="true" 
                        :validate="validate"
                        v-model="value.campos_customizados.js_campos" 
                        :saved="saved" 
                        :mode="edicao ? 'fixed' : 'view'"
                        :config="true" />
                </div>
            </div>

            <div v-if="!noButtons">

                <div class="row mt-1" v-if="edicao">
                    <div class="col col-12 col-md-12 text-right">
                        <button class="btn btn-outline-secondary btn-sm mr-2" @click="cancelar ()">Cancelar</button>
                        <az-submit sizing="sm" @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
                <div class="row mt-1" v-else>
                    <div class="col col-12 col-md-3 d-flex align-items-end">
                        <span class="small text-muted" title="Id do Paciente">[{{ value.id_pessoa }}]</span>
                        <span class="small text-muted ml-2" title="Criado em..." v-if="value.created_at">desde {{ $util.getFormatDate(value.created_at) }}</span>
                    </div>
                    <div class="col col-12 col-md-9 text-right">
                        <button class="btn btn-link" @click="gerar_login_portal()" v-if="value.portal_resultado && !value.terceiro_login">Gerar Login Portal</button>
                        <button class="btn btn-link" @click="enviar_convite_portal()" v-if="value.portal_resultado">Convite Portal</button>
                        <button v-if="is_coopeder_buttons()" class="btn btn-link" @click="abrir_logs_coopeder()">Logs Coopeder</button>
                        <az-audit-log-button sizing="sm" :link="true" model="paciente" :id="value.id_pessoa" />
                        <button class="btn btn-link" @click="edicao = !edicao">Editar</button>

                        <template v-if="value.id_pessoa && value.arquivos">
                            <button class="btn btn-link" @click="carregar_arquivos(true)">
                                <i class="fa-solid fa-paperclip fa-fw" v-if="value.arquivos.length"></i>
                                <i class="fa fa-plus" aria-hidden="true" v-else></i>
                            </button>
                        </template>
                    </div>
                </div>
            </div>

            </form>

            <ul class="list-group mt-3" v-if="value.terceiro_login">
                <li class="list-group-item d-flex justify-content-between">
                    <div>
                        <a href="#" @click.prevent="exibir_login = !exibir_login" class="mr-3">
                            <i class="fa-solid fa-eye-slash fa-fw" v-if="!exibir_login"></i>
                            <i class="fas fa-eye fa-fw" v-else></i>
                        </a>
                        <span v-if="exibir_login">Login: {{ value.terceiro_login.st_login }} / Senha: {{ value.terceiro_login.st_senha }}</span>
                        <span v-else>Login: ****** / Senha: *******</span>
                    </div>
                    <div v-if="value.terceiro_login.terceiro">
                        <span class="small text-muted">{{ value.terceiro_login.terceiro.st_sigla }}</span>
                        <span v-if="value.terceiro_login.terceiro.st_sigla.toLowerCase() == 'klis'">
                            <a href="#" @click.prevent="regerar_senha(value.terceiro_login)" data-toggle="tooltip" data-placement="left" title="Regerar Senha" class="ml-3">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </a>
                        </span>
                    </div>
                    <div v-else>
                        <a href="#" @click.prevent="regerar_senha(value.terceiro_login)" data-toggle="tooltip" data-placement="left" title="Regerar Senha" class="ml-3">
                            <i class="fa-solid fa-arrows-rotate"></i>
                        </a>
                    </div>
                </li>
            </ul>

            <ul class="list-group mt-3" v-if="value.portal_usuarios">
                <li class="list-group-item d-flex justify-content-between" v-for="(pusuario, ipx) in value.portal_usuarios" :key="ipx">
                    <div>
                        Login: {{ pusuario.st_login }}
                    </div>
                    <div>
                        <a href="#" @click.prevent="toggle_user_bloq(pusuario)" class="mr-2">
                            <i class="fa-regular fa-circle text-primary fa-fw" title="Acesso liberado" v-if="!pusuario.fl_bloqueado"></i>
                            <i class="fa-solid fa-ban text-danger fa-fw" title="Acesso bloqueado" v-else></i>
                        </a>
                    </div>
                </li>
            </ul>

        </div>

        <pre v-if="1 == 0">{{ value.sinalizadores }}</pre> 
        <log-integracao v-if="log_integracao" ref="logint" />

        <!-- Upload de Arquivo para o Legado -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload_pac_pl"
                :multiple="true"
                @refresh="refresh_arquivos"
                :arquivos="value.arquivos"
                :parms="{ 
                    model_type: 'pessoa', 
                    model_id: value.id_pessoa,
                    fechar_ao_enviar: true  
                }" />
        </template>

        <!-- Modal de Informações de Origem do Cadastro Temporário -->
        <div class="modal fade" id="infoOrigemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Verificação de Dados</h5>
                        <button type="button" class="close" @click="fechar_modal('infoOrigemModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="info_origem">
                        <table class="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>Atualizar</th>
                                    <th>Campo</th>
                                    <th>Cadastro Atual</th>
                                    <th>Informado (Novo)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(campo, icx) in info_origem" :key="icx" :class="campo.selec ? 'table-success' : ''">
                                    <td><input type="checkbox" class="form form-control" v-model="campo.selec"></td>
                                    <td>{{ campo.label }}</td>
                                    <td>{{ formatar(campo.origem, campo) }}</td>
                                    <td>{{ formatar(campo.value, campo) }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ info_origem }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('infoOrigemModal')">Fechar</button>
                        <button type="button" class="btn btn-success" @click="atualizar_dados_origem()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import CadastroEndereco from './CadastroEndereco.vue';
import AzInput from './forms/AzInput.vue'
import AzSubTitle from '../util/AzSubTitle.vue'
import AzSubmit from '../util/AzSubmit.vue';
import { required } from 'vuelidate/lib/validators'; 
import ServicoOperadora from './ServicoOperadora.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import Formulario from '../modulos/consultorio/Formulario.vue';
import PagamentoPendente from './PagamentoPendente.vue';
import LogIntegracao from './audit/LogIntegracao.vue';
import AzFileUpload from "../util/AzFileUpload.vue";
// minLength

export default {
    data () { 
        return { 
            edicao: false,
            campos_customizados: null, 
            saved: true, 
            sinalizadores: null, 
            acao_anexar: false, 
            exibir_login: false, 
            info_origem: null, 
        }
    },
    validations: {
        value: {
            paciente_unidade: { 
                plano: required
            },
        },
    },
    watch: {
        value: {
            handler() {
                //this.value.paciente.paciente_unidade.id_plano = this.value.paciente.paciente_unidade.plano ? 
                //    this.value.paciente.paciente_unidade.plano.id_plano : null;

                if ( this.value && this.value.cadastro && !this.value.cadastro.endereco) { 
                    this.value.cadastro.endereco = {};
                }

                this.$emit('input', this.value);
            },
            deep: true,
            immediate: true,
        },

        editar: { 
            handler() {
                if ( this.editar === true || this.editar === false ) { 
                    this.edicao = this.editar;
                }
            },
            deep: true,
            immediate: true,
        },

    },
    computed: { 
        tem_prontuario: function () { 
            return ( this.$store.state.unidade 
                && this.$store.state.unidade.parametro_unidade
                && this.$store.state.unidade.parametro_unidade.fl_numero_prontuario ) ? true : false; 
        },
        
        idade: function () { 
            if ( !this.value || !this.value.cadastro || !this.value.cadastro.dt_nascimento )
                return;

            let today = moment();
            let birthdateMoment = moment(this.dados.paciente.cadastro.dt_nascimento, 'YYYY-MM-DD');
            
            return today.diff(birthdateMoment, 'years');
        },

        fl_sus: function() { 
            return this.value.paciente_unidade.plano && this.value.paciente_unidade.plano.operadora && this.value.paciente_unidade.plano.operadora.fl_sus;
        },
        fl_particular: function () { 
            return this.value.paciente_unidade.plano 
                && this.value.paciente_unidade.plano.id_operadora == 1 
                && !this.value.paciente_unidade.plano.fl_validade_particular
        }
    },
    
    components: { 
        CadastroEndereco,
        AzInput,
        AzSubTitle,
        AzSubmit,
        ServicoOperadora,
        AzAuditLogButton,
        Formulario,
        PagamentoPendente, 
        LogIntegracao,
        AzFileUpload, 
    },

    props: [
        'value', 
        'editar', 
        'noButtons', 
        'formName', 
        'validate', 
        'marcacao', 
        'log_integracao', 
        'sus_block_obrig',
        'block_operadora',
        'block_alter_nome', 
    ],

    methods: { 
        atualizar_dados_origem () { 
            this.info_origem.filter(campo => campo.selec)
                .forEach(campo => { 
                    _.set(this.value, campo.id, campo.value);
                });

            this.fechar_modal('infoOrigemModal');
        },

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },

        formatar (valor, campo) { 

            if ( valor ) { 
                switch (campo.type) {
                    case 'date':
                        return this.$util.getFormatDate(valor);

                    case 'fone':
                        return this.telefone(valor);

                }
            }

            return valor;

        },

        toggle_user_bloq (usuario) { 
            if ( !confirm('Confirma alterar a condição de acesso (bloqueado/liberado)?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'pacientes',
                func: 'toggle_usuario_acesso', 
                dados: { 
                    id_pessoa: usuario.id_pessoa, 
                    id_usuario: usuario.id_usuario
                },
                toast: true, 
                callback: res => { 
                    if ( res.usuario ) { 
                        usuario.fl_bloqueado = res.usuario.fl_bloqueado;
                    }
                }
            });

        },

        regerar_senha (tl) { 
            if ( this.$store.state.loading ) { 
                return;
            }

            if ( !confirm('Confirma regerar a senha do paciente?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'regerar_senha_portal', 
                dados: { 
                    login: tl.st_login, 
                },
                callback: res => { 
                    if ( res && res.st_login ) { 
                        tl.st_senha = res.st_senha;

                        this.$toast.add({ 
                            severity: "success",
                            summary: "Atualizar",
                            detail: "Senha atualizada.",
                            life: 3000
                        });
                    }
                }
            });
        },

        refresh_arquivos () { 
            this.carregar_arquivos();
        },
        
        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.value.id_pessoa,
                    type: 'pessoa',
                }
            })
            .then(res => {
                this.value.arquivos = res;
                this.acao_anexar = true;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload_pac_pl.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });


        },

        abrir_arquivos () { 
            this.acao_anexar = true; 

            this.$nextTick(() => { 
                this.$refs.upload_pac_pl.abrir();
            });
        },

        is_coopeder() { 
            return (this.$store.state.dominio == 'coopeder' || this.$store.state.dominio == 'teste') && this.noButtons;
        },

        is_coopeder_buttons() { 
            return (this.$store.state.dominio == 'coopeder' || this.$store.state.dominio == 'teste');
        },

        copiar_clipboard (texto) { 
            this.$util.copiar_clipboard(this, texto);
        },

        whatsapp_web (numero, pc = null) { 
            let msg = "";
            let celular = "";

            celular = numero;
            
            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = ( pc == '+' ? '' : "55" ) + celular;

            return "https://wa.me/" + celular + "?text=" + msg;
        },

        sinalizador_selecionado (sinalizador) { 
            if ( !this.value.sinalizadores ) { 
                this.value.sinalizadores = [];
                this.$forceUpdate();
            }

            return this.value.sinalizadores.find(sinal => sinal.id_sinalizador_atendimento == sinalizador.id_sinalizador_atendimento && !sinal.excluido) ? true : false;
        },

        toggle_sinalizador(sinalizador) { 
            if ( !this.value.sinalizadores ) { 
                this.value.sinalizadores = [];
            }

            let item = this.value.sinalizadores.find(sinal => sinal.id_sinalizador_atendimento == sinalizador.id_sinalizador_atendimento);

            if ( item ) { 
                item.excluido = !item.excluido;
            } else { 
                this.value.sinalizadores.push({ 
                    id_sinalizador_atendimento: sinalizador.id_sinalizador_atendimento,
                    excluido: false,
                });
            }

            this.$forceUpdate();
        },

        gerar_login_portal () { 
            if ( !confirm('Confirma gerar o login de acesso ao portal de resultados para o paciente?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'pacientes',
                func: 'gerar_login_portal',
                dados: { 
                    id_paciente: this.value.id_pessoa, 
                },
                toast: true, 
                callback: res => { 
                    if ( res.login && res.login.st_login ) { 
                        this.value.terceiro_login = res.login;
                    }
                }
            });
        },

        enviar_convite_portal() { 
            if ( !confirm('Confirma enviar o convite de acesso ao portal de resultados para o paciente?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'pacientes',
                func: 'convite_portal',
                dados: { 
                    id_paciente: this.value.id_pessoa, 
                },
                toast: true, 
            });
        },
        gerar_prontuario() { 
            if ( !confirm('Confirma gerar o número de prontuário?') ) 
                return; 

            this.$util.load(this, { 
                service: 'pacientes',
                func: 'gerar_prontuario',
                loadTo: res => { 
                    this.value.paciente_unidade.st_numero_prontuario = res;
                }
            });
        },

        elegibilidade(value) { 
            this.value.paciente_unidade.eleg = value; 
        },

        validar() { 
            //
        },

        salvar () { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'pacientes.store', 
                    id: "retorno", 
                    parms: { 
                        paciente: this.value 
                    }
                } 
            ]};

            this.axios.post('/aql', query)
                .then(res => { 

                    if ( res.data.retorno.status == 200 ) { 

                        this.$toast.add({
                                severity: "success",
                                summary: "Atualizar",
                                detail: "Cadastro atualizado.",
                                life: 3000
                            });
                        this.edicao = false;

                        this.$emit('atualizado');

                    }
                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                });

        },

        atualizar () { 

            let invalids = $('#cad_paciente .invalid');

            if ( invalids.length ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Verificar preenchimento dos campos.",
                    life: 3000
                });

            } else { 

                if ( !this.value.id_pessoa ) { 

                    this.$store.commit('loading', true);

                    if ( this.value.paciente.cadastro.idade_anos < 18 && this.value.paciente.cadastro.st_cpf ) { 

                        this.salvar ();

                    } else if ( this.value.paciente.cadastro.fl_estrangeiro ) { 

                        this.salvar ();
                        
                    } else { 

                        this.$util.loadItem(this, { 
                            service: 'pacientes',
                            func: 'checar_duplicidade',
                            parms: this.value,
                        })
                        .then(lista => { 
                            if ( lista.length ) { 
                                alert('Paciente já cadastrado.');
                                return;
                            } else { 
                                this.salvar ();
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);        
                        });

                    }

                } else { 

                    this.salvar();

                }

            }
        },

        cancelar () { 
            this.edicao = false;
            this.$emit('cancelar');
        },

        abrir_logs_coopeder() {
            this.$refs.logint.abrir('paciente', this.value.id_pessoa, true, 'Xml');
        },

        telefone (telefone) { 
            if ( !telefone )
                return "";

            let textoAjustado = "(" + telefone.slice(0,2) + ") ";
            if(telefone.length == 11) {
                const parte1 = telefone.slice(2,7);
                const parte2 = telefone.slice(7,11);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`        
            } else {
                const parte1 = telefone.slice(2,6);
                const parte2 = telefone.slice(6,10);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`
            }

            return textoAjustado;
        },
    },
    mounted () { 
        this.info_origem = null;
        this.sinalizadores = _.cloneDeep(this.$store.state.user.sinalizadores);

        if ( this.value && this.value.info_origem ) { 
            this.info_origem = _.cloneDeep(this.value.info_origem);
            this.value.info_origem = null;

            if ( this.info_origem.length ) { 
                $('#infoOrigemModal').modal('show');
            }
        }
    }
}
</script>
